import { memo } from 'react'

import { Navigate, useLocation } from 'react-router-dom'

export const LegacyClusterOfficeRedirect = memo(() => {
  const { pathname } = useLocation()

  return (
    <Navigate
      to={pathname
        .replace(/^\/cluster-office\/([^/]+)\/v2\/(\d+)$/, '/$1s/$2')
        .replace('spreadsheet', 'cell')}
      replace
    />
  )
})
